import { ExerciseData } from '../../exercises';
import React from 'react';
import { Exercise } from '../../components';
import { StressAndSleep } from '../../../articles/StressAndSleep';

export const exerciseData14: ExerciseData = {
    ExerciseView: Module1Exercise4,
    dataKeys: [],
    questions: [],
};

function Module1Exercise4() {
    return (
        <Exercise title="Stress og søvn">
            <StressAndSleep />
        </Exercise>
    );
}
